// extracted by mini-css-extract-plugin
export default {"asideFooter":"index_asideFooter__hm8la"};